<template>
    <div id="users-view" class="view users-table">
        <settings-menu></settings-menu>

        <users-table table-title="Users"></users-table>

    </div>
</template>

<script>
import SettingsMenu from '../../components/layout/SettingsMenu'
import UsersTable from './components/UsersTable'

const body = document.body

export default {
    name: 'Users',
    mounted () {
        body.classList.add('devices-view')
    },
    beforeDestroy () {
        body.classList.remove('devices-view')
    },
    components: {
        UsersTable,
        SettingsMenu
    }
}
</script>

<style scoped lang="scss">
.users-table {
    margin-bottom: 30px;

    .v-btn {
        &.margin-right {
            margin-right: 10px !important;
        }
    }
}
</style>
